import BaseApi from "./BaseApi";

export function getSitesApi() {
  return BaseApi.get("/site/search");
}

export function getCo2Input(siteId) {
  const url = `/site/${siteId}/co2`;
  return BaseApi.get(url);
}

export function putCo2Input(siteId, data) {
  const url = `/site/${siteId}/co2`;
  return BaseApi.put(url, data);
}

export function getMetaDataSite(siteId) {
  return BaseApi.get(`/site/${siteId}/meta`);
}

export function putMetaDataSite(siteId, data) {
  return BaseApi.put(`/site/${siteId}/meta`, data);
}

export function generateKyExcel(siteId, diaryDate, diaryPeriod) {
  return BaseApi.post('/site/generate-ky-excel', { 
    siteId, 
    diaryDate, 
    diaryPeriod 
  });
}

export function generateSiteDailyWorkRecordExcel(siteId, startDate, endDate) {
  return BaseApi.post('/site-daily-work-records/generate-excel', { 
    siteId, 
    startDate, 
    endDate 
  });
}

export function getSiteUserMe(siteId) {
  return BaseApi.get(`/site-users/me?siteId=${siteId}`);
}

export function getSiteContractCompanies(siteId) {
  return BaseApi.get(`/site/${siteId}/contract-companies`);
}
